import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { T, F } from 'ramda'

import SeriesDetail from './series-detail'
import SeriesList from './series-list'
import BackToTop from '../shared/back-to-top'
import { SCREEN_SIZE_BREAKPOINTS } from '../../constants'
import { getShowPageMargin } from '../../lib/utils'
import SERIES_COMPONENT_FRAGMENT from '../../../graphql/fragments/series-component.gql'

import { JSONLD } from '../jsonld/index'
import { createSeriesLDSchema } from '../../lib/jsonld/series'
import ContentDescription from '../shared/content-description'
import { useAddToMyListQS } from '../../hooks/use-add-to-my-list-qs'

function Series({
  component, theme, screenWidth, addToMyList, removeFromMyList, isContentItemOnMyList
}) {
  const { series } = component
  useAddToMyListQS(series)
  const margin = getShowPageMargin(screenWidth)
  const isMobileView = screenWidth <= SCREEN_SIZE_BREAKPOINTS.MIN_480

  return (
    <>
      <SeriesDetail
        contentItem={series}
        showSquareHeroImage={isMobileView} // Update the hero image to be 1:1 ratio on mobile view
        margin={margin}
      />

      <ContentDescription contentItem={series} margin={margin} />

      <SeriesList
        series={series}
        addToMyList={addToMyList}
        removeFromMyList={removeFromMyList}
        isContentItemOnMyList={isContentItemOnMyList}
        theme={theme}
        margin={margin}
      />

      {!isMobileView && <BackToTop />}

      <JSONLD schema={createSeriesLDSchema(series)} type="TVSeries" />
    </>
  )
}

Series.propTypes = {
  component: propType(SERIES_COMPONENT_FRAGMENT).isRequired,
  theme: PropTypes.string.isRequired,
  screenWidth: PropTypes.number.isRequired,
  addToMyList: PropTypes.func,
  removeFromMyList: PropTypes.func,
  isContentItemOnMyList: PropTypes.func
}

Series.defaultProps = {
  addToMyList: T,
  removeFromMyList: T,
  isContentItemOnMyList: F
}

export default Series
